var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { action, makeObservable, observable } from 'mobx';
class VersionDialogState {
    constructor() {
        this.left = 200;
        this.top = 200;
        this.show = false;
        this.title = "Document";
        this.dragging = false;
        this.versions = new Map();
        this.loading = false;
        this.addingversion = false;
        this.activatedid = "";
        this.activatingversion = "";
        makeObservable(this);
    }
    setActivatedVeriosn(fileid) {
        this.activatedid = fileid;
    }
    setActivatingVeriosn(fileid) {
        this.activatingversion = fileid;
    }
    setAddingVersion(adding) {
        this.addingversion = adding;
    }
    setLoading(loading) {
        this.loading = loading;
    }
    setVersions(vs) {
        this.versions.clear();
        vs.forEach((v) => this.versions.set(v.versionnumber + "", v));
    }
    addVersion(v) {
        this.versions.set(v.versionnumber + '', v);
    }
    getVersions() {
        return Array.from(this.versions.values()).sort((v1, v2) => v1.versionnumber - v2.versionnumber).reverse();
    }
    setDragging(drag) {
        this.dragging = drag;
    }
    setTitle(title) {
        this.title = title;
    }
    setShow(show) {
        this.show = show;
    }
    setLeft(left) {
        this.left = left;
    }
    setTop(top) {
        this.top = top;
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], VersionDialogState.prototype, "left", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], VersionDialogState.prototype, "top", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], VersionDialogState.prototype, "show", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], VersionDialogState.prototype, "title", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], VersionDialogState.prototype, "dragging", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], VersionDialogState.prototype, "versions", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], VersionDialogState.prototype, "loading", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], VersionDialogState.prototype, "addingversion", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], VersionDialogState.prototype, "activatedid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], VersionDialogState.prototype, "activatingversion", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], VersionDialogState.prototype, "setActivatedVeriosn", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], VersionDialogState.prototype, "setActivatingVeriosn", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], VersionDialogState.prototype, "setAddingVersion", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], VersionDialogState.prototype, "setLoading", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], VersionDialogState.prototype, "setVersions", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], VersionDialogState.prototype, "addVersion", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], VersionDialogState.prototype, "setDragging", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], VersionDialogState.prototype, "setTitle", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], VersionDialogState.prototype, "setShow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], VersionDialogState.prototype, "setLeft", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], VersionDialogState.prototype, "setTop", null);
export const VDState = new VersionDialogState();
